/* ========== SCATTER (XY) & BUBBLE CHARTS ========== */

import { COLORS, drawAxes, drawGridlines, drawLegend, niceAxis } from './utils';

export function drawScatterChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;

  var allX = [], allY = [];
  seriesArr.forEach(function (s) {
    var xd = s.xData || s.data.map(function (_, i) { return i; });
    xd.forEach(function (v) { allX.push(v); });
    s.data.forEach(function (v) { allY.push(v); });
  });

  // Excel-like nice scales on BOTH value axes (authored min/max/format win).
  var xAx = niceAxis(Math.min.apply(null, allX), Math.max.apply(null, allX), { axis: chartObj.xValAxis, lengthPx: width });
  var yAx = niceAxis(Math.min.apply(null, allY), Math.max.apply(null, allY), { axis: chartObj.valAxis, lengthPx: height });
  var xMin = xAx.minValue;
  var yMin = yAx.minValue;
  var xRange = xAx.range;
  var yRange = yAx.range;

  drawGridlines(ctx, x, y, width, height, yMin, yRange, yAx.numGridLines, yAx.label);

  ctx.strokeStyle = '#E0E0E0';
  ctx.lineWidth = 1;
  var xGrid = xAx.numGridLines;
  for (var gi = 0; gi <= xGrid; gi++) {
    var gx = x + (gi / xGrid) * width;
    ctx.beginPath();
    ctx.moveTo(gx, y);
    ctx.lineTo(gx, y + height);
    ctx.stroke();
    var xv = xMin + (gi / xGrid) * xRange;
    ctx.fillStyle = '#888';
    ctx.font = '9px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(xAx.label(xv), gx, y + height + 4);
  }

  seriesArr.forEach(function (series, sIdx) {
    var xd = series.xData || series.data.map(function (_, i) { return i; });
    var color = COLORS[sIdx % COLORS.length];
    series.data.forEach(function (yVal, i) {
      var xVal = xd[i] !== undefined ? xd[i] : i;
      var px = x + ((xVal - xMin) / xRange) * width;
      var py = y + height - ((yVal - yMin) / yRange) * height;
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(px, py, 4, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = '#fff';
      ctx.lineWidth = 1;
      ctx.stroke();
    });
  });

  drawAxes(ctx, x, y, width, height);
  drawLegend(ctx, x, y, width, height, seriesArr);
}

export function drawBubbleChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;

  var allX = [], allY = [], allSizes = [];
  seriesArr.forEach(function (s) {
    var xd = s.xData || s.data.map(function (_, i) { return i; });
    xd.forEach(function (v) { allX.push(v); });
    s.data.forEach(function (v) { allY.push(v); });
    if (s.bubbleSizes) s.bubbleSizes.forEach(function (v) { allSizes.push(Math.abs(v)); });
  });

  var xAx = niceAxis(Math.min.apply(null, allX), Math.max.apply(null, allX), { axis: chartObj.xValAxis, lengthPx: width });
  var yAx = niceAxis(Math.min.apply(null, allY), Math.max.apply(null, allY), { axis: chartObj.valAxis, lengthPx: height });
  var xMin = xAx.minValue;
  var yMin = yAx.minValue;
  var xRange = xAx.range;
  var yRange = yAx.range;
  var maxSize = allSizes.length > 0 ? Math.max.apply(null, allSizes.concat([1])) : 1;

  drawGridlines(ctx, x, y, width, height, yMin, yRange, yAx.numGridLines, yAx.label);

  seriesArr.forEach(function (series, sIdx) {
    var xd = series.xData || series.data.map(function (_, i) { return i; });
    var sizes = series.bubbleSizes || series.data.map(function () { return maxSize; });
    var color = COLORS[sIdx % COLORS.length];

    series.data.forEach(function (yVal, i) {
      var xVal = xd[i] !== undefined ? xd[i] : i;
      var px = x + ((xVal - xMin) / xRange) * width;
      var py = y + height - ((yVal - yMin) / yRange) * height;
      var sizeVal = Math.abs(sizes[i] || 1);
      var r = Math.max(4, Math.min(30, (sizeVal / maxSize) * 25));

      ctx.globalAlpha = 0.55;
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(px, py, r, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalAlpha = 1;
      ctx.strokeStyle = color;
      ctx.lineWidth = 1.5;
      ctx.stroke();
    });
  });

  drawAxes(ctx, x, y, width, height);
  drawLegend(ctx, x, y, width, height, seriesArr);
}
